import { postSwitchOrganization } from '../../api';
import { setJWTToken } from '@sonar-software/sonar-ts-lib';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const securitySwitchOrganizationPostAsyncSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.ORGANIZATION_SWITCHED),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successDataHandlers: [
			(data) => {
				if (data.token) {
					setJWTToken(data.token);
				}
			}
		]
	},
	name: 'SecuritySwitchOrganization',
	receive: false,
	request: true,
	requestHandler: postSwitchOrganization
});
